import Lookup from 'src/componentes/select2';

const StatusItem = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/StatusItemLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default StatusItem;
